import _ from 'lodash';

import getRemainingAttributes from '@/components/vehicle-detail-header-filter/utils/get-remaining-attributes';
import getNextFilterAttribute from '@/components/vehicle-detail-header-filter/utils/get-next-filter-attribute';
import buildFilterOptions from '@/components/vehicle-detail-header-filter/utils/build-filter-options';
import {
  ATTRIBUTES,
  DEFAULT_ATTRIBUTE,
  FILTERS_LIMIT,
  OPTIONS_LIMIT,
} from '@/components/vehicle-detail-header-filter/utils/constants';

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'variants' implicitly has an 'any' type.
const sortVariants = (variants, sortAttribute) => {
  return _.orderBy(variants, [sortAttribute], ['asc']);
};

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'variants' implicitly has an 'any' type.
const getNextFilter = (variants, filters = []) => {
  const sortedVariants = sortVariants(variants, 'sequenceNumber');
  const remainingAttributes = getRemainingAttributes(filters, ATTRIBUTES);
  const isDefaultAttributeRemaining = _.includes(remainingAttributes, DEFAULT_ATTRIBUTE);

  if (variants.length < OPTIONS_LIMIT) {
    // console.log(`getNextFilter(): Number of variants is under limit: `, variants);
    if (isDefaultAttributeRemaining) {
      // console.log(`...create the last filter using default attribute.`);
      const options = buildFilterOptions(sortedVariants, DEFAULT_ATTRIBUTE, true);
      const baseModel = _.find(options, ({ isBaseOption }) => isBaseOption === 'T');
      const optionsWithBaseModelIdentified = _.map(options, (option) => {
        if (option === baseModel) {
          return { ...option, value: `${option.value} (Base Model)` };
        }
        return option;
      });
      return {
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: 'DEFAULT_ATTRIBUTE' is possibly 'undefined'.
        label: DEFAULT_ATTRIBUTE.name,
        options: optionsWithBaseModelIdentified,
      };
    }
    // console.log(`...and default filter already exists - stop creating new filters.`);
    return null;
  }

  // console.log(`getNextFilter(): Number of variants is over limit (${variants.length})`);
  if (filters.length <= FILTERS_LIMIT) {
    const attributeToFilter = getNextFilterAttribute(sortedVariants, remainingAttributes, OPTIONS_LIMIT);
    // console.log(
    //   `getNextFilter(): Identified next attribute to filter based on preference and number of options: `,
    //   attributeToFilter
    // );
    if (attributeToFilter) {
      const options = buildFilterOptions(variants, attributeToFilter, true);
      return {
        label: attributeToFilter.name,
        options,
      };
    }
  } else {
    // console.log(
    //   `getNextFilter(): Too many filters (${filters.length}) already, create the last filter using default attribute`
    // );
    return {
      // @ts-expect-error [🤖 PLEASE FIX 🤖]: 'DEFAULT_ATTRIBUTE' is possibly 'undefined'.
      label: DEFAULT_ATTRIBUTE.name,
      options: buildFilterOptions(sortedVariants, DEFAULT_ATTRIBUTE, true),
    };
  }

  return null;
};

export default getNextFilter;

export { ATTRIBUTES, DEFAULT_ATTRIBUTE, OPTIONS_LIMIT };
